import { FC } from "react";
import { Text } from "@/components/atoms/Text";
import StarIcon from "@/icons/__generated__/Star/Star16";
import StarFilledIcon from "@/icons/__generated__/StarFilled/StarFilled16";
import StarHalfIcon from "@/icons/__generated__/StarHalf/StarHalf16";

interface StarsProps {
  reviewStars: number;
  reviewCount: number;
}

export const Stars: FC<StarsProps> = ({ reviewStars, reviewCount }) => {
  const populateStars = (reviewStars: number) => {
    const starsInt = reviewStars ? parseFloat(reviewStars.toFixed(1)) : 0;
    let stars: React.ReactElement[] = [];

    if (starsInt === 0) {
      return stars;
    }

    const halfStar = starsInt - Math.floor(starsInt);

    for (let i = 1; i <= Math.floor(starsInt); i++) {
      stars.push(<StarFilledIcon key={`filled-${i}`} />);
    }

    if (starsInt % 1 !== 0) {
      if (0.25 < halfStar && 0.75 > halfStar) {
        stars.push(<StarHalfIcon key="half" />);
      } else if (0.25 > halfStar) {
        stars.push(<StarIcon key="empty-half" />);
      } else {
        stars.push(<StarFilledIcon key="filled-half" />);
      }
    }

    const emptyStars = 5 - Math.ceil(starsInt);

    for (let j = 1; j <= emptyStars; j++) {
      stars.push(<StarIcon key={`empty-${j}`} />);
    }

    return stars;
  };

  if (reviewStars && reviewCount) {
    return (
      <div className="stars-wrapper tw-flex tw-items-center">
        {populateStars(reviewStars).map((star, i) => (
          <div key={i} className="star tw-flex tw-items-center tw--mt-1">
            {star}
          </div>
        ))}
        <Text typeface="body-2" className="tw-ml-8">
          {reviewCount}
        </Text>
      </div>
    );
  }

  return null;
};
